export default __webpack_public_path__ + "static/media/hemicraniectomia_descomprensiva.a12f6bb6.pdf";